import React from "react";
import { useSelector } from "react-redux";
import MuiSidebar from "./MuiSidebar";
import { TAB_SIZE } from "../../constants/ThemeSetting";

const Sidebar = () => {
  const { width, navStyle } = useSelector(({ settings }) => settings);

  // For small screens and certain nav styles, we'll keep the default drawer behavior
  const shouldUseMuiSidebar = width >= TAB_SIZE;

  return (
    <>
      {shouldUseMuiSidebar ? (
        <MuiSidebar />
      ) : (
        <div style={{ display: "none" }}>
          {/* Placeholder for mobile sidebar */}
        </div>
      )}
    </>
  );
};

export default Sidebar;
